<main class="d-flex align-items-center flex-column">
  <mat-icon
    class="no-connection-image"
    svgIcon="app_slow_connection_icon"
  ></mat-icon>
  <p>{{ data.message }}</p>
</main>
